var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.remainSeconds > 3600)?_c('div',{staticClass:"time",staticStyle:{"color":"#ffffff"}},[_vm._v(" 진행중 ")]):_c('div',{staticClass:"time",staticStyle:{"color":"#ffffff"}},[_vm._v(" "+_vm._s(_vm._f("twoDigits")(_vm.minutes))+":"+_vm._s(_vm._f("twoDigits")(_vm.seconds))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }